module.exports = __webpack_public_path__ + "static/media/P5.d84e9e2e.jpg";